import React from "react";

import {
  FaBalanceScale,
  FaInfoCircle,
  FaShieldAlt,
} from "react-icons/fa";

const ITEMS = [
  {
    icon: FaInfoCircle,
    title: "Résultat indicatif",
    text: "La convocation de la compétition reste toujours la référence.",
  },
  {
    icon: FaBalanceScale,
    title: "Pesée officielle",
    text: "La catégorie définitive est validée lors de la pesée.",
  },
  {
    icon: FaShieldAlt,
    title: "Pas de données conservées",
    text: "La date de naissance et le poids ne sont ni envoyés ni enregistrés.",
  },
];

export default function CategoryInfoNotice() {
  return (
    <section className="overflow-hidden rounded-[2rem] bg-slate-950 p-6 text-white sm:p-8">
      <div className="grid gap-6 sm:grid-cols-3">
        {ITEMS.map((item) => {
          const Icon = item.icon;

          return (
            <article
              key={item.title}
              className="rounded-2xl border border-white/10 bg-white/5 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-400 text-slate-950">
                <Icon />
              </span>

              <h3 className="mt-4 font-black">
                {item.title}
              </h3>

              <p className="mt-2 text-sm leading-6 text-slate-400">
                {item.text}
              </p>
            </article>
          );
        })}
      </div>
    </section>
  );
}